<div style="display: flex; flex-direction: column; height: 100%;" class="position-relative text-grey"
  cdkDrag cdkDragRootElement=".cdk-overlay-pane" 
  cdkDragBoundary="body" 
  [cdkDragDisabled]="!toggleDialog">
  <div class="modal-header" cdkDragHandle>
    <h4  
      class="modal-title synchpc-primary flex-grow-1" 
      id="modal-title"
      *ngIf="!this.data.depId"
      title="{{ jobFileName }}"
    >
      File : {{ jobFileName | shortenString:trimIndex }}
    </h4>
    <h4
      class="modal-title synchpc-primary flex-grow-1" 
      id="modal-title"
      *ngIf="this.data.depId"
      title="Status of {{ this.depName }}"
    >
      {{ depName }} Deployment Status
    </h4>
    <div class="fileSearch" *ngIf="!toggleDialog">
      <div class="inputAndResults">
        <input
          class="searchInput"
          type="text"
          placeholder="Search"
          value="{{ searchTerm }}"
          (input)="searchKeyword($event.target.value)"
        />
        <label class="searchResults" for=""
          >{{ currentWordIndex }}/{{ totalWordCount }}</label
        >
      </div>
      <div class="searchIcons">
        <button
          class="isCaseSensitive"
          (click)="makeCaseSensitive()"
          title="{{ isSensitiveTitle }}"
          [ngStyle]="
            isSensitive ? { color: 'var(--s-primary-color)', 'font-weight': '600' } : {}
          "
        >
          Aa
        </button>
        <span
          title="Previous"
          [class.iconDisabled]="totalWordCount == 0"
          (click)="findPrevious()"
          class="bi bi-arrow-up-short"
        ></span>
        <span
          title="Next"
          [class.iconDisabled]="totalWordCount == 0"
          (click)="findNext()"
          class="bi bi-arrow-down-short"
        ></span>
        <span
          title="Clear Search"
          (click)="clearSearch()"
          class="bi bi-x-lg text-danger"
        ></span>
      </div>
    </div>
    <i
      style="z-index: 9999; margin-right: 1rem"
      class="bi bi-arrows-fullscreen text-danger"
      [ngClass]="{
        'bi-arrows-fullscreen': !toggleFullScreen,
        'bi-fullscreen-exit': toggleFullScreen
      }"
      [title]="toggleFullScreen ? 'Exit full screen' : 'Full screen'"
      color="warn"
      (click)="onFullScreen()"
    ></i>
    <i
      style="z-index: 9999; margin-right: 1rem"
      class="bi bi-dash text-danger"
      [ngClass]="{
        'bi-dash-lg': !toggleDialog,
        'bi-fullscreen': toggleDialog,
        'minmax-dialog': toggleDialog
      }"
      color="warn"
      (click)="toggleDialogMinMax()"
      [title]="toggleDialog ? 'Maximize' : 'Minimize'"
    ></i>
    <i
      style="z-index: 9999"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="dialogRef.close(false)"
      title="Close"
    ></i>
  </div>
  <!-- <button class="fileEditSaveBtn" title="Edit File" (click)="onEdit()" *ngIf="contentEditable == false"><span class="bi bi-pencil"></span></button>
  <button class="fileEditSaveBtn" title="Save File" (click)="onSave()" *ngIf="contentEditable"><span class="bi bi-clipboard"></span></button> -->
  
  <mat-dialog-content #scrollMe class="mat-typography outputContent">
    <div #JobOutputDiv>
      <p
        *ngIf="contentEditable == false && toShowPipe == true"
        readyonly
        style="
          white-space: pre-wrap;
          outline: none;
          width: 100%;
          font-size: .8rem;
          color: white;
          border: none;
          background-color: black;
        "
        [innerHTML]="jobOutput | highlight: searchTerm:regexCode"
      ></p>
      <p
        #editedFile
        contenteditable="true"
        *ngIf="contentEditable == true"
        style="
          white-space: pre-wrap;
          outline: none;
          width: 100%;
          color: white;
          border: none;
          background-color: black;
        "
        [innerHTML]="jobOutput | highlight: searchTerm:regexCode"
      ></p>
      <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%">
        No Logs Available.
      </p>
    </div>
  </mat-dialog-content>

<div class="modal-footer">
  @if(totalFileLines != -1){
    <mat-paginator #paginator
      [ngClass]="{'d-none': !toShowPaginator}"
      class="demo-paginator"
      (page)="handlePageEvent($event)"
      [length]="totalFileLines"
      [pageSize]="linePerPage"
      [disabled]="false"
      [showFirstLastButtons]="showFirstLastButtons"
      [pageSizeOptions]="showPageSizeOptions ? pageLineOptions : []"
      [hidePageSize]="hidePageSize"
      [pageIndex]="currentPageIndex"
      aria-label="Select page">
    </mat-paginator>
  }
    <button
      title="{{ !this.data.depId ? ' Refresh Job Output Once' : 'Refresh Deployment Status'}}"
      type="button"
      (click)="manualRefresh()"
      [disabled]="!disabled || this.manualDisable || contentEditable"
      class="btn btn-primary"
    >
      Manual Refresh
    </button>
    <button
      title="{{ !this.data.depId ? ' Job Output will be refresh every 7 seconds' : ' Deployment Status will be refresh every 7 seconds'}}"
      type="button"
      (click)="autoRefresh()"
      [disabled]="!disabled || contentEditable"
      class="btn btn-primary"
    >
      Auto Refresh
    </button>
    <button
      title="Pause Auto Refresh"
      (click)="pause()"
      [disabled]="disabled || contentEditable"
      class="btn btn-primary"
    >
      Pause
    </button>
    <button
      title="Close"
      type="button"
      (click)="onCancel()"
      [disabled]="!disabled"
      class="btn btn-primary"
    >
      Close
    </button>
  </div>
</div>
<ngx-spinner
  id="jobOutputSpinner"
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="white"
  type="ball-spin"
  [fullScreen]="false"
  style="z-index: 1000 !important"
  class="text-grey"
  ></ngx-spinner
>
